import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/bootstrap-select.min.css";
import "../css/bootstrap-slider.min.css";
import "../css/bootstrap.min.css";

import "../css/flaticon.min.css";
import "../css/loader.min.css";
import "../css/magnific-popup.min.css";
import "../css/Navbar.css";

import "../css/skin/skin-1.css";
import "../plugins/revolution/revolution/css/settings.css";
import "../plugins/revolution/revolution/css/navigation.css";

import "../css/fontawesome/css/font-awesome.min.css";
import "../css/fontawesome/fonts/fontawesome-webfont.eot";
import "../css/fontawesome/fonts/fontawesome-webfont.svg";
import "../css/fontawesome/fonts/fontawesome-webfont.ttf";
import "../css/fontawesome/fonts/fontawesome-webfont.woff";
import "../css/fontawesome/fonts/fontawesome-webfont.woff2";
import "../css/owl.carousel.min.css";
import "../css/fontawesome/less/animated.less";

import "../css/fontawesome/less/bordered-pulled.less";
import "../css/fontawesome/less/core.less";
import "../css/fontawesome/less/fixed-width.less";
import "../css/fontawesome/less/font-awesome.less";
import "../css/fontawesome/less/icons.less";
import "../css/fontawesome/less/larger.less";
import "../css/fontawesome/less/list.less";
import "../css/fontawesome/less/mixins.less";
import "../css/fontawesome/less/path.less";
import "../css/fontawesome/less/rotated-flipped.less";
import "../css/fontawesome/less/screen-reader.less";
import "../css/fontawesome/less/stacked.less";
import "../css/home.css";
import lithiumbattery from "../img/hm/slider/lithiumimg.jpeg";
import lithiumbattery1 from "../img/hm/lithium-battery.jpg";
import ledlights from "../img/hm/slider/led-lights-manufacturing.jpg";
import ledlights1 from "../img/hm/slider/led-lights-manufacturing.jpg";
import sheetmetal from "../img/hm/slider/sheet-metal.jpg";
import sheetmetal1 from "../img/hm/slider/sheet-metal.jpg";
import "../img/hm/mohali-factory.jpg";

import mohalifactoryimg from "../img/hm/mohali-factory.jpg";
import rajpurafactory from "../img/hm/rajpura-factory.jpg";
import ledcob from "../img/hm/led-cob.jpg";
import lightingmachine from "../img/hm/lighting-machine.jpg";
import lithiummachine from "../img/hm/lithiummachine.jpg";
import sledlights from "../img/hm/services/led-lights.jpg";
import slithiumbattry from "../img/hm/services/lithium-battery.jpg";
import slithiuminvertor from "../img/hm/services/lithium-inverter.jpg";
import ssheetmetal from "../img/hm/services/steel-sheet-metal.jpg";

import award2017 from "../img/hm/award/2017.png";
import award2018 from "../img/hm/award/2018.png";
import award2019 from "../img/hm/award/2019.png";
import award2020 from "../img/hm/award/2020.png";
import award2021 from "../img/hm/award/2021.png";

import isonew from "../img/hm/award-certifications/iso-new.png";
import fc from "../img/hm/award-certifications/fc.png";
import ce from "../img/hm/award-certifications/ce.png";
import msme from "../img/hm/award-certifications/msme.png";
import nsic from "../img/hm/award-certifications/nsic.png";
import trademark from "../img/hm/award-certifications/trademark.png";

import img1 from "../img/clients/1.png";
import img5 from "../img/clients/5.png";
import img6 from "../img/clients/6.png";
import img9 from "../img/clients/9.png";
import img12 from "../img/clients/12.png";
import img14 from "../img/clients/14.png";

import bg4 from "../images/background/bg-4.png";
import crossline2 from "../images/background/cross-line2.png";
import bg12 from "../images/background/bg-12.jpg";
import companycatalog from "../catalogues/Spinoff-Technopark-Ltd.pdf"
function Home() {

  const [isExpanded, setIsExpanded] = useState(false);

  const fullText = `During the initial journey of evolution in the Lighting industry when CFL started fading out and LED started emerging as a technologically advanced product, Spinoffs’ started the Punjabs’ 1st manufacturing operations of LED lights , in the Industrial Area of Mohali in the year 2014. This facility is equipped with highly skilled R&D and New Product Development teams and along with most advanced machineries commenced with 12 SKUs in 2014-15 in Phase –I. Thereafter, Spinoff started manufacturing COB Lights and took the total SKUs from 12 to 40 Nos, in 2016-17 with improvement in the product design and style in the home segment. With focused approach to enhance variety for the customers, consistent quality and innovation we scaled up the SKUs count to 100 Nos in 2018-19 and then to 200 SKUs in 2020. By this time we had, along with Retail customers had started adding the Corporate customers as well. The SKU count grew steadily and from 400 Nos in 2021 moved to 600 Nos in 2022 and then to 700 SKUs in 2023. In the year 2024, management envisioned the growth potential in the Lithium Battery space and along with the next phase of NPD and capacity expansion for Mohali LED factory new manufacturing location was set up at Rajpura for Lithium along with Sheet metal products. We intend to create our presence in various power electronic segments connected with Green energy storage system for multiple application across different areas of universe- Aeronautical, DRONE, Railways ESS solutions, Portable ESS etc. With our own set up in R&D, design house, and manufacturing- we have already started the process of Tool room set up and molding section. In addition to the Lithium Energy application based on Engineering aspect, we look forward to scale new heights with Spinoff Technopark Ltd.`;

  const shortText = fullText.substring(0, 250) + "...";


  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  const slides = [
    {
      image: ledlights,
      title: "LED Lights Manufacturing",
      description: "Leading the Way in High-Performance LED Lighting",
      link: "our-services/led-lights",
    },
    {
      image: lithiumbattery,
      title: "Lithium Battery Manufacturing",
      description: "Powering the Future with Advanced Lithium Solutions",
      link: "our-services/lithium-battery",
    },
    {
      image: sheetmetal,
      title: "Stainless Steel Sheet Metal Working",
      description: "Precision-Engineered Sheet Metal for Your Every Need",
      link: "our-services/sheet-metal",
    },
  ];

  const images = [
    mohalifactoryimg,
    lightingmachine,
    lithiumbattery1,
    ledcob,
    lithiummachine,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  // Function to go to the previous image
  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Function to go to the next image
  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };
  return (
    <div className="page-content">
      <div className="simple-slider">
        <div
          className="slider-content"
          style={{ backgroundImage: `url(${slides[currentSlide].image})` }}
        >
          <div className="slider-overlay">
            <h2>{slides[currentSlide].title}</h2>
            <p>{slides[currentSlide].description}</p>
            {/*  <a
              href={slides[currentSlide].link}
              className="site-button btn-half"
            >
            </a>*/}
          </div>
        </div>
      </div>

      <div
        className="section-full mobile-page-padding p-t80 p-b80 bg-white bg-no-repeat bg-bottom-left"
        style={{ backgroundImage: `url(${bg4}) ` }}
      >
        <div className="container">
          {/* TITLE START */}
          <div className="section-head">
            <div className="sx-separator-outer separator-left">
              <div
                className="sx-separator bg-white bg-moving bg-repeat-x"
                style={{
                  backgroundImage: `url(${crossline2}) `,
                }}
              >
                <h3 className="sep-line-one">Who We Are</h3>
              </div>
            </div>
          </div>
          {/* TITLE END */}
          <div className="section-content">
            <div className="row">
              <div className="col-lg-5 col-md-12 col-sm-12">
                <div className="about-home-left">
                  <h3 className="m-t0 sx-tilte">
                    Power Electronics Solution Under one Roof
                  </h3>
                  {/* <p>
                  In 2013, Spinoff took an initiative to get in manufacturing by starting with R&D driven approach for NPD in LED lights, by doing product development in LED bulb and LED tube lights with power electronics division.  In 2014-15, after successful trial of NPD Spinoff started manufacturing LED bulb, Tube lights etc. Then in 2016-17- We started manufacturing COB lights in down lighter category.

In the year 2017-23 from the previous number of 40 SKUs in production- we scaled up the new product range to 700 SKUs. This resulted in capacity expansion for our Mohali Lighting factory so that our capability to capture LED project lighting and decorative lights’ segment is enhanced. Additionally, new CNC laser cut and CNC bending machines were deployed in the sheet metal body division for creating lights’ housing and its drivers.

Moreover, in the year 2024- we launched the 8th phase of NPD and capacity expansion for Mohali LED factory and Rajpura manufacturing location. We intend to create our presence in various power electronic segments connected with Green energy storage system for multiple application across different areas of universe- Aeronautical, DRONE, Railways ESS solutions, Portable ESS etc.  

With our own set up in R&D, design house

                  </p>*/}
                  <p>{isExpanded ? fullText : shortText}</p>
      
      {/* Read More / Read Less Button */}
      <button onClick={() => setIsExpanded(!isExpanded)} className="readMoreBtn">
        {isExpanded ? "Read Less" : "Read More"}
      </button>
                  <div className="text-left">
                    <a
                      href={companycatalog}
                      className="site-button-secondry btn-half"
                      target="_blank"
                    >
                      About Us
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-12 col-sm-12">
                <div className="about-home-right">
                  <div
                    className="slider-container"
                    style={{ position: "relative", textAlign: "center" }}
                  >
                    {/* Previous button */}
                    <button
                      className="prev-btn"
                      onClick={goToPrev}
                      style={{
                        position: "absolute",
                        left: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "24px",
                      }}
                    >
                      &lt;
                    </button>

                    <div className="item sx-img-effect zoom-slow">
                      <img
                        src={images[currentIndex]}
                        alt={`Image ${currentIndex + 1}`}
                      />
                      <button
                        className="next-btn"
                        onClick={goToNext}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "24px",
                        }}
                      >
                        &gt;
                      </button>
                    </div>
                  </div>

                  <div className="about-home-before">
                    <img src={rajpurafactory} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ABOUT COMPANY END */}
      {/* OUR SERVICES START */}
      <div className="section-full mobile-page-padding p-t80 bg-white bg-change-section">
        <div className="container">
          {/* TITLE START */}
          <div className="section-head">
            <div className="sx-separator-outer separator-center">
              <div
                className="sx-separator bg-white bg-moving bg-repeat-x"
                style={{
                  backgroundImage: `url(${crossline2}) `,
                }}
              >
                <h3 className="sep-line-one">Our Manufacturing Verticals</h3>
              </div>
            </div>
          </div>
          {/* TITLE END */}
        </div>
        <div className="homecards">
          {/* led lights */}
          <div className="item">
            <Link to="our-services/led-lights"></Link>
            <div
              className="bgcall-block d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
              style={{ backgroundImage: `url(${sledlights}) ` }}
            >
              <Link to="our-services/led-lights">
                <div className="overlay-main bg-black opacity-05" />
              </Link>
              <div className="bg-content-mid-outer">
                <Link to="our-services/led-lights"></Link>
                <div className="bg-content-mid">
                  <Link to="our-services/led-lights"></Link>
                  <div className="sx-icon-box-wraper center   text-white">
                    <Link to="our-services/led-lights">
                      <div className="icon-lg m-b15">
                        <span className="icon-cell">
                          <i className="flaticon-living-room" />
                        </span>
                      </div>
                    </Link>
                    <div className="icon-content">
                      <Link to="our-services/led-lights"></Link>
                      <h4 className="sx-tilte">
                        <Link to="our-services/led-lights"></Link>
                        <Link
                          to="our-services/led-lights"
                          className="sx-text-white"
                        >
                          {" "}
                          LED Lights
                        </Link>
                      </h4>
                    </div>
                  </div>
                  <span className="bgcall-block-number">01</span>
                  <div className="bg-overlay" />
                </div>
              </div>
            </div>
          </div>
          {/* lithium battery */}
          <div className="item">
            <Link
              to="our-services/lithium-battery"
              className="sx-text-white"
            ></Link>
            <div
              className="bgcall-block d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
              style={{
                backgroundImage: `url(${slithiumbattry}) `,
              }}
            >
              <Link to="our-services/lithium-battery" className="sx-text-white">
                <div className="overlay-main bg-black opacity-05" />
              </Link>
              <div className="bg-content-mid-outer">
                <Link
                  to="our-services/lithium-battery"
                  className="sx-text-white"
                ></Link>

                <div className="bg-content-mid">
                  <Link
                    to="our-services/lithium-battery"
                    className="sx-text-white"
                  ></Link>
                  <div className="sx-icon-box-wraper center   text-white">
                    <Link
                      to="our-services/lithium-battery"
                      className="sx-text-white"
                    >
                      <div className="icon-lg m-b15">
                        <span className="icon-cell">
                          <i className="flaticon-3d" />
                        </span>
                      </div>
                    </Link>
                    <div className="icon-content">
                      <Link
                        to="our-services/lithium-battery"
                        className="sx-text-white"
                      ></Link>
                      <h4 className="sx-tilte">
                        <Link
                          to="our-services/lithium-battery"
                          className="sx-text-white"
                        ></Link>
                        <Link
                          to="our-services/lithium-battery"
                          className="sx-text-white"
                        >
                          Lithium Battery
                        </Link>
                      </h4>
                    </div>
                  </div>
                  <span className="bgcall-block-number">02</span>
                  <div className="bg-overlay" />
                </div>
              </div>
            </div>
          </div>
          {/* Inverter & UPS Manufacturing */}
          <div className="item">
            {" "}
            <Link
              to="our-services/inverter-ups"
              className="sx-text-white"
            ></Link>
            <div
              className="bgcall-block d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
              style={{
                backgroundImage: `url(${slithiuminvertor}) `,
              }}
            >
              <Link to="our-services/inverter-ups" className="sx-text-white">
                <div className="overlay-main bg-black opacity-05" />
              </Link>
              <div className="bg-content-mid-outer">
                <Link
                  to="our-services/inverter-ups"
                  className="sx-text-white"
                ></Link>
                <div className="bg-content-mid">
                  <Link
                    to="our-services/inverter-ups"
                    className="sx-text-white"
                  ></Link>
                  <div className="sx-icon-box-wraper center   text-white">
                    <Link
                      to="our-services/inverter-ups"
                      className="sx-text-white"
                    >
                      <div className="icon-lg m-b15">
                        <span className="icon-cell">
                          <i className="flaticon-mirror" />
                        </span>
                      </div>
                    </Link>
                    <div className="icon-content">
                      <Link
                        to="our-services/inverter-ups"
                        className="sx-text-white"
                      ></Link>
                      <h4 className="sx-tilte">
                        <Link
                          to="our-services/inverter-ups"
                          className="sx-text-white"
                        ></Link>
                        <Link
                          to="our-services/inverter-ups"
                          className="sx-text-white"
                        >
                          Lithium Inverter &amp; UPS
                        </Link>
                      </h4>
                    </div>
                  </div>
                  <span className="bgcall-block-number">03</span>
                  <div className="bg-overlay" />
                </div>
              </div>
            </div>
          </div>
          {/* sheet metal */}
          <div className="item">
            <Link
              to="our-services/sheet-metal"
              className="sx-text-white"
            ></Link>

            <div
              className="bgcall-block d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
              style={{
                backgroundImage: `url(${ssheetmetal}) `,
              }}
            >
              <Link to="our-services/sheet-metal" className="sx-text-white">
                <div className="overlay-main bg-black opacity-05" />
              </Link>
              <div className="bg-content-mid-outer">
                <Link
                  to="our-services/sheet-metal"
                  className="sx-text-white"
                ></Link>
                <div className="bg-content-mid">
                  <Link
                    to="our-services/sheet-metal"
                    className="sx-text-white"
                  ></Link>
                  <div className="sx-icon-box-wraper center   text-white">
                    <Link
                      to="our-services/sheet-metal"
                      className="sx-text-white"
                    >
                      <div className="icon-lg m-b15">
                        <span className="icon-cell">
                          <i className="flaticon-dimensions" />{" "}
                        </span>
                      </div>
                    </Link>
                    <div className="icon-content">
                      <Link
                        to="our-services/sheet-metal"
                        className="sx-text-white"
                      ></Link>
                      <h4 className="sx-tilte">
                        <Link
                          to="our-services/sheet-metal"
                          className="sx-text-white"
                        ></Link>
                        <Link
                          to="our-services/sheet-metal"
                          className="sx-text-white"
                        >
                          Sheet Metal
                        </Link>
                      </h4>
                    </div>
                  </div>
                  <span className="bgcall-block-number">04</span>
                  <div className="bg-overlay" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-full  mobile-page-padding bg-gray  p-t80 p-b10 bg-repeat bg-gray">
        <div className="container">
          <div className="section-head">
            <div className="sx-separator-outer separator-left">
              <div
                className="sx-separator bg-white bg-moving bg-repeat-x"
                style={{
                  backgroundImage: `url(${crossline2}) `,
                }}
              >
                <h3 className="sep-line-one">Award &amp; Recognitions</h3>
              </div>
            </div>
          </div>
          {/* TITLE END */}
          <div className="section-content">
            <div className="client-grid m-b40">
              <div className="row justify-content-center">
                <div className="col-lg-2 col-md-4 col-sm-6 col-6 m-b30">
                  <p href="#" className="client-logo-pic">
                    <img src={award2017} alt="" />
                    <div>
                      <span>2017 Award</span>
                    </div>
                  </p>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-6 col-6 m-b30">
                  <p href="javascript:;" className="client-logo-pic">
                    <img src={award2018} alt="" />
                    <div>
                      <span>2018 Award</span>
                    </div>
                  </p>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-6 col-6  m-b30">
                  <p href="javascript:;" className="client-logo-pic">
                    <img src={award2019} alt="" />
                    <div>
                      <span>2019 Award</span>
                    </div>
                  </p>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-6 col-6  m-b30">
                  <p href="javascript:;" className="client-logo-pic">
                    <img src={award2020} alt="" />
                    <div>
                      <span>2020 Award</span>
                    </div>
                  </p>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-6 col-6  m-b30">
                  <p href="javascript:;" className="client-logo-pic">
                    <img src={award2021} alt="" />
                    <div>
                      <span>2021 Award</span>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hilite-title text-left p-l50 text-uppercase">
          <strong>Award</strong>
        </div>
      </div>

      <div
        className="section-full  mobile-page-padding bg-gray  p-t80 p-b10 bg-repeat"
        style={{ backgroundImage: `url(${bg12}) ` }}
      >
        <div className="container">
          {/* TITLE START */}
          <div className="section-head">
            <div className="sx-separator-outer separator-left">
              <div
                className="sx-separator bg-white bg-moving bg-repeat-x"
                style={{
                  backgroundImage: "url(images/background/cross-line2.png)",
                }}
              >
                <h3 className="sep-line-one">Certifications</h3>
              </div>
            </div>
          </div>
          {/* TITLE END */}
          <div className="section-content">
            <div className="client-grid m-b40">
              <div className="row justify-content-center">
                <div className="col-lg-2 col-md-4 col-sm-6 col-6 m-b30">
                  <p href="javascript:;" className="client-logo-pic">
                    <img src={isonew} alt="" />
                    <div>
                      <span>ISO</span>
                    </div>
                  </p>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-6 col-6 m-b30">
                  <p href="javascript:;" className="client-logo-pic">
                    <img src={ce} alt="" />
                    <div>
                      <span>CE</span>
                    </div>
                  </p>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-6 col-6  m-b30">
                  <p href="javascript:;" className="client-logo-pic">
                    <img src={fc} alt="" />
                    <div>
                      <span>FC</span>
                    </div>
                  </p>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-6 col-6  m-b30">
                  <p href="javascript:;" className="client-logo-pic">
                    <img src={msme} alt="" />
                    <div>
                      <span>MSME</span>
                    </div>
                  </p>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-6 col-6  m-b30">
                  <p href="javascript:;" className="client-logo-pic">
                    <img src={nsic} alt="" />
                    <div>
                      <span>NSIC</span>
                    </div>
                  </p>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-6 col-6  m-b30">
                  <p href="javascript:;" className="client-logo-pic">
                    <img src={trademark} alt="" />
                    <div>
                      <span>Trademark</span>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hilite-title text-left p-l50 text-uppercase">
          <strong>CERTIFICATE</strong>
        </div>
      </div>
      {/*
  <div className="section-full mobile-page-padding p-tb30 bg-gray">
  <h3 className="sep-line-one">Our Customers</h3>
    <div className="container">
      <div className="section-content owl-btn-vertical-center">
        <div className="owl-carousel home-client-carousel-2">
          <div className="item">
            <a href="javascript:;" className="client-logo-pic">
              <img src={img1} alt="" />
              <div>
                <span>Allround</span>
              </div>
            </a>
          </div>
          <div className="item">
            <a href="javascript:;" className="client-logo-pic">
              <img src={img5} alt="" />
              <div>
                <span>SBI</span>
              </div>
            </a>
          </div>
          <div className="item">
            <a href="javascript:;" className="client-logo-pic">
              <img src={img6} alt="" />
              <div>
                <span>NABL</span>
              </div>
            </a>
          </div>
          <div className="item">
            <a href="javascript:;" className="client-logo-pic">
              <img src={img9} alt="" />
              <div>
                <span>PP</span>
              </div>
            </a>
          </div>
          <div className="item">
            <a href="javascript:;" className="client-logo-pic">
              <img src={img12} alt="" />
              <div>
                <span>SBI Life</span>
              </div>
            </a>
          </div>
          <div className="item">
            <a href="javascript:;" className="client-logo-pic">
              <img src={img14} alt="" />
              <div>
                <span>McDonald's</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>*/}
    </div>
  );
}

export default Home;
